<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
    <div class="tit page">  
      <h1>Declaração de IRPF</h1>
    </div>
    <form>
        <div class="margin">
        <files-input :files="arquivos" :accept="formatosAceitos"
            :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
        </div>
        <div class="text-center fixedOptions">
        <button class="btn btn-primary" @click="onSubmit">Próximo <img src="../../assets/images/angle-right.svg"></button>
        </div>
    </form>
  </div>
</template>

<script>
import FilesInput from '@/components/FilesInput'
import ArrayHelper from '@/utils/array-helper'

export default {
  components: {
    FilesInput
  },
  data() {
    const social = this.currentUser.Social
    return {
      /* eslint-disable */  
      uploadEndpoint: process.env.API_NODE+'/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: social.ArquivoDeclaracaoIRPF || [null]
    }
  },
  computed: {
    arquivosRecebidos: function() {
      return this.arquivos.filter(arquivo => {
        return arquivo != null && arquivo != undefined
      })
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles
    },
    removeFile(index) {
      this.arquivos.splice(index, 1)
    },
    clearFile(index) {
      this.$set(this.arquivos, index, null)
    },
    validate() {
      if(this.arquivosRecebidos.length > 0) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['O envio da Declaração de IRPF é obrigatória']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()

      if(validation.isValid) {
        
        this.currentUser.Social.ArquivoDeclaracaoIRPF = this.arquivosRecebidos
        
        this.$emit('on-submit', {Social: this.currentUser.Social})
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/FileUploadDeclaracaoIRStep.vue